export const HINT_GENRES = 'hintGenres'
export const HINT_SET_REACH = 'hintSetReach'
export const HINT_LANGUAGES = 'hintLanguages'
export const HINT_PRICE = 'hintPrice'
export const HINT_ESTIMATE = 'hintEstimate'
export const CLEAR_HINT = 'clearHint'
